import React from "react";

class Popup extends React.Component {
  state = {
    isShow: true
  };

  handleClose = () => {
    this.setState({ isShow: false });
  };

  render() {
    if (!this.state.isShow) {
      return null;
    }

    return (
      <div className="popup">
        <div className="cover">
          <div className="content">
            <p>
              เนื่องจากสถานการณ์การแพร่ระบาดของเชื้อไวรัส COVID-19
              เพื่อป้องกันการแพร่ระบาด และเพื่อสุขอนามัยของผู้เข้าร่วมงาน
              ทีมผู้จัดงานขอเลื่อนวันจัดกิจกรรม Thailand Data Challenge 2020
              ในวันที่ 28 มีนาคม 2563
              และจะแจ้งกำหนดวันแข่งขันใหม่ให้ทราบอีกครั้ง
            </p>
            <p>
              ทั้งนี้
              ทางเรายังคงสถานะการสมัครสำหรับทีมที่ได้ลงทะเบียนเข้าแข่งขันสำเร็จเรียบร้อย
              และจะมีการส่งข้อความยืนยันการเข้าแข่งขันให้ทุกทีมอีกครั้งก่อนวันงาน
            </p>
            <p>ทางคณะผู้จัดงานต้องขออภัยมา ณ ที่นี้</p>
            <hr />
            <p>
            In light of growing concerns around COVID-19,  we are taking extra precautionary measures to ensure the well being of our personnel and Thailand's society. In this regard, we regret to inform you that Thailand Data Challenge 2020 has been postponed until further notice.
            </p>
            <p>
            Despite that, registration will remain the same for all interested individuals. The event attendance confirmation will be submitted to all registered teams accordingly.
            </p>
            <div className="bottom">
            <button className="ok-button" onClick={() => this.handleClose()}>
              OK
            </button>
            </div>
          </div>
          <div className="x-button" onClick={() => this.handleClose()}></div>
        </div>
      </div>
    );
  }
}
export default Popup;
